export default __webpack_public_path__ + "static/media/filled-doctor.c2587f65.svg";